module.exports = __webpack_public_path__ + "prod/20261104151832/img/purpose.cda92bb6.png";